import cx from '../../../../utils/cx';

import Typography, { FONT_TYPES } from '../Typography/Typography';

import checkIcon from '../../../../images/quiz/check.svg';

import styles from './CheckboxButton.module.scss';

const CheckboxButton = ({ id, name, value, className, children, ...rest }) => {
  return (
    <>
      <input
        type="checkbox"
        id={id}
        name={name}
        value={value}
        className={styles.input}
        {...rest}
      />
      <label htmlFor={id} className={cx(styles.label, className)}>
        <span className={styles.checkbox}>
          <img src={checkIcon} alt="" />
        </span>
        <Typography type={FONT_TYPES.body_semibold} htmlTag="span" isCenter>
          {children}
        </Typography>
      </label>
    </>
  );
};

export default CheckboxButton;
